import {cn} from '@/lib/utils/helpers';

export default function Container({children, className, edgePadding = true}) {
  return (
    <div className={cn(
      'container xl:px-container',
      {'mx-4 max-md:w-auto md:mx-auto md:px-4': edgePadding},
      className,
    )}
    >
      {children}
    </div>
  );
};
